<template>
  <div>
    <div class="page-header">
      <v-layout row align-center>
        <v-icon x-large>mdi-calendar-month</v-icon>
        <h1 class="page-title">{{ pageTitle }}</h1>
      </v-layout>
    </div>
    <v-form v-model="valid">
      <v-container>
        <v-row>
          <v-col cols="12" lg="3" md="6" sm="12">
            <v-text-field
              v-model="calendarEvent.title"
              label="Title"
              :rules="titleRules"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="3" md="6" sm="12">
            <v-checkbox
              v-model="calendarEvent.isAllDay"
              label="Is All Day"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" lg="3" md="6" sm="12">
            <v-select
              label="Color"
              :items="colors"
              v-model="calendarEvent.eventColorId"
              item-value="id"
              item-text="name"
            >
              <template slot="selection" slot-scope="{ item }">
                <div>{{ item.name }}</div>
              </template>
              <template slot="item" slot-scope="{ item }">
                <div>{{ item.name }}</div>
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" lg="3" md="6" sm="12">
            <v-text-field
              v-model="calendarEvent.url"
              label="Url"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-textarea
              v-model="calendarEvent.description"
              label="Description"
              :rules="descriptionRules"
              required
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" lg="6" md="6" sm="12">
            <v-date-picker
              v-model="calendarEvent.startDate"
              class="picker"
              full-width
              required
            ></v-date-picker>
          </v-col>
          <v-col cols="12" lg="6" md="6" sm="12">
            <v-date-picker
              v-model="calendarEvent.endDate"
              class="picker"
              full-width
              required
            ></v-date-picker>
          </v-col>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-btn outlined color="accent" class="mr-4" @click="onBack"
            >Back</v-btn
          >
          <v-btn
            outlined
            :disabled="!valid"
            class="mr-4"
            @click="onSubmit"
            >Submit</v-btn
          >
        </v-row>
      </v-container>
    </v-form>
    <div>
      <statusalert ref="alert" returnUrl="/calendar"></statusalert>
    </div>
  </div>
</template>
<script>
import CalendarEventsService from '../../services/api/CalendarEventsService.js'
import store from '@/store/index.js'
import router from '@/router/index.js'
import statusalert from '../../components/StatusAlert'
import authorizedMixin from '../../mixins/authorizedMixin'
  
export default {
  name: 'news-edit',
  mixins: [authorizedMixin],
  components: {
    statusalert
  },

  store: store,

  computed: {
    priviledged() {
      return (
        this.$store.getters.getAdministrator || this.$store.getters.getProShop
      )
    }
  },

  data() {
    return {
      result: null,
      pageTitle: 'Add Calendar Event',
      colors: [
        { id: 0, name: 'Red' },
        { id: 1, name: 'Green' },
        { id: 2, name: 'Blue' },
        { id: 3, name: 'Dark Red' },
        { id: 4, name: 'Dark Green' },
        { id: 5, name: 'Dark Blue' },
        { id: 6, name: 'Orange' },
        { id: 7, name: 'Grey' }
      ],
      value: [0, 1, 2, 3, 4, 5, 6, 7],
      calendarEvent: {
        calendarEventId: 0,
        title: '',
        description: '',
        startDate: new Date().toISOString().substring(0, 10),
        endDate: new Date().toISOString().substring(0, 10),
        isAllDay: false,
        eventColorId: 0,
        url: ''
      },
      descriptionRules: [
        v => !!v || 'Description is required',
        v => v.length <= 256 || 'Name must be 256 characters or less'
      ],
      titleRules: [
        v => !!v || 'Title is required',
        v => v.length <= 80 || 'Name must be 80 characters or less'
      ],
      valid: false
    }
  },

  created() {
    if (!this.priviledged) {
      router.push('/unauth/')
    }

    store.commit('loading')
    if (this.$route.params.calendarEventId > 0) {
      this.pageTitle = 'Edit Calendar Event'
      CalendarEventsService.getEvent(this.$route.params.calendarEventId)
        .then(data => {
          this.calendarEvent = data
          this.calendarEvent.startDate = this.calendarEvent.startDate.substring(
            0,
            10
          )
          this.calendarEvent.endDate = this.calendarEvent.endDate.substring(
            0,
            10
          )
        })
        .catch(error => console.log(error))
        .finally(() => {
          store.commit('notLoading')
        })
    }
  },

  methods: {
    onSubmit() {
      store.commit('isLoading')
      this.result = {}
      if (this.calendarEvent.calendarEventId === 0) {
        CalendarEventsService.create(this.calendarEvent)
          .then(result => {
            this.result = {
              isValid: true, 
              statusCode: result.status,
              errors: ['Calendar event created']
            }
          })
          .catch(error => {
            console.log(error)
            this.result = {
              isValid: false,
              statusCode: 404,
              errors: ['Failed to create calendar event']
            }
          })
          .finally(() => {
            store.commit('notLoading')
            this.displayAlert()
          })
      } else {
        CalendarEventsService.update(this.calendarEvent)
          .then(result => {
            this.result = {
              isValid: true, 
              statusCode: result.status,
              errors: ['Calendar event updated']
            }
          })
          .catch(error => {
            console.log(error)
            this.result = {
              isValid: false,
              statusCode: 404,
              errors: ['Failed to update calendar event']
            }
          })
          .finally(() => {
            store.commit('notLoading')
            this.displayAlert()
          })
      }
    },

    onBack() {
      router.push('/calendar')
    },

    displayAlert() {
      this.$refs.alert.displayResult(this.result)
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
